'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasl';
var iconName = 'clock-rotate-left';
var width = 512;
var height = 512;
var aliases = ["history"];
var unicode = 'f1da';
var svgPathData = 'M32 132l0-100-32 0 0 160 160 0 0-32-106.4 0C89.5 84.3 166.7 32 256 32 379.7 32 480 132.3 480 256S379.7 480 256 480c-73.3 0-138.3-35.2-179.2-89.6l-9.6-12.8-25.6 19.2 9.6 12.8C97.9 471.8 172.2 512 256 512 397.4 512 512 397.4 512 256S397.4 0 256 0C159.6 0 75.7 53.3 32 132zm240-4l-32 0 0 134.6 4.7 4.7 80 80 11.3 11.3 22.6-22.6-11.3-11.3-75.3-75.3 0-121.4z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faClockRotateLeft = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;